import React from "react";
import Accordion from "react-bootstrap/Accordion";

const SimAccordion = ({ children, defaultActiveKey = null }) => {
  return (
    <>
      <Accordion defaultActiveKey={defaultActiveKey}>
        {React.Children.map(children, (child, index) => (
          <Accordion.Item eventKey={index.toString()}>
            <Accordion.Header>{child.props.heading}</Accordion.Header>
            <Accordion.Body>{child}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
};

export default SimAccordion;
